import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const SeverityCircleShape = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
  flex-shrink: 0;
`

const DimOverlay = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(50, 50, 50, 0.3);
`

const SeverityText = styled.div`
  text-align: center;
`

export const SeverityCircle: FC<{
  annotation: KVAnnotation
  severity: string
}> = ({ annotation, severity }) => {
  const normalized = (severity || '').trim().toLowerCase()

  // Background color mapping supports numeric, Navy, and Aerospace severities
  const bgColor =
    severity === '1'
      ? 'rgb(209, 209, 205)'
      : severity === '2'
        ? 'rgb(223, 214, 98)'
        : severity === '3' || severity === 'N/V' || normalized === 'moderate'
          ? 'rgb(223, 174, 2)'
          : severity === '4'
            ? 'rgb(219, 109, 0)'
            : severity === '5' || normalized === 'flight critical'
              ? 'rgb(179, 0, 0)'
              : normalized === 'minor'
                ? 'rgb(209, 209, 205)'
                : 'rgb(80, 80, 80)'

  // Display text: show full for numeric/Navy
  // Abberviate for aerospace or convert to 1/2 for minor moderate
  const displayText = ['1', '2', '3', '4', '5', 'N/V'].includes(severity)
    ? severity
    : normalized === 'minor'
      ? '1'
      : normalized === 'moderate'
        ? '2'
        : normalized === 'flight critical'
          ? 'FC'
          : normalized === 'unknown'
            ? 'U'
            : severity

  const fontSize = displayText === 'N/V' ? 9 : 12

  return (
    <SeverityCircleShape style={{ backgroundColor: bgColor }} title={severity}>
      {!annotation.visible && <DimOverlay />}
      <SeverityText style={{ fontSize: fontSize }}>{displayText}</SeverityText>
    </SeverityCircleShape>
  )
}
